import { createSlice } from "@reduxjs/toolkit";

const saveCountLatest = createSlice({
    name: "counts",
    initialState: {},
    reducers: {
        incrementCount: (state, action) => {
            const id = action.payload;
            const currentCount = state[id] || 0;
            state[id] = currentCount + 1;
        },
        decrementCount: (state, action) => {
            const id = action.payload;
            const currentCount = state[id] || 0;
            if (currentCount > 0) {
                state[id] = currentCount - 1;
            }
        },
        resetCounts: () => {
            return {};
        },
    },
});

export const { incrementCount, decrementCount, resetCounts } =
    saveCountLatest.actions;
export default saveCountLatest.reducer;
